module.exports = __webpack_public_path__ + "static/media/feature_flag.bc847db1.jpeg";